import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { CreateAndTermsConditionModal } from '@frontend/payments-setup';
import { theme } from '@frontend/theme';
import { useFormField, useModalControl, RadioField, Button } from '@frontend/design-system';
import { PaymentsSetupProps } from './no-invoices.types';

export const PaymentsSetup = ({
  stripeCreatedNotOnboarded = false,
  isSettingsPage = false,
  refetchQueries,
  locationId,
}: PaymentsSetupProps) => {
  const { t } = useTranslation('payments');

  const radioFieldProps = useFormField({ type: 'radio', required: true });
  const { modalProps: creationCheckModalProps, triggerProps: creationCheckTriggerProps } = useModalControl();

  const buttonTitle = isSettingsPage ? t('Create Stripe Account') : t('Setup Account');
  const businessTypeRadioLabel = isSettingsPage ? t('Please select the type of Business') : t('Type of Business');

  return (
    <>
      {!stripeCreatedNotOnboarded && (
        <RadioField
          name='business_type'
          label={businessTypeRadioLabel}
          {...radioFieldProps}
          css={css`
            min-width: min-content;
            max-width: 300px;
          `}
          data-trackingid={'portal-payments_setup-stripe_type-of-business_radio'}
        >
          <RadioField.Radio value='COMPANY'>{t('Business')}</RadioField.Radio>
          <RadioField.Radio value='NON_PROFIT'>{t('Nonprofit Organization')}</RadioField.Radio>
          <RadioField.Radio value='INDIVIDUAL'>{t('Individual')}</RadioField.Radio>
        </RadioField>
      )}
      <Button
        variant='primary'
        css={css`
          margin-bottom: ${theme.spacing(3)};
          margin-top: ${!stripeCreatedNotOnboarded ? theme.spacing(3) : 0};
          width: max-content;
        `}
        disabled={!radioFieldProps.value && !stripeCreatedNotOnboarded}
        size='large'
        {...creationCheckTriggerProps}
        trackingId='portal-payments_setup-stripe_create-account_button'
      >
        {stripeCreatedNotOnboarded ? t('Continue Onboarding') : buttonTitle}
      </Button>
      <CreateAndTermsConditionModal
        businessType={radioFieldProps.value}
        creationCheckModalProps={creationCheckModalProps}
        refetchQueries={refetchQueries}
        locationId={locationId}
      />
    </>
  );
};
